import React, { useMemo } from 'react';
import { useGlobalSubscription } from 'providers/GlobalCacheManager';
import { FOLDER_RESPONSIBLE_UPDATED } from '../../folder/edit/generalData/info/subscriptions';
import { getInt } from 'utils/functions';
import { useParams } from 'react-router-dom';
import { useSubscription } from '@apollo/client';
import { DOCUMENT_UPDATED } from 'features/document/edit/subscriptions';
import { showInfo } from 'actions/actionCreators/snackbarActions';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectUserId } from 'selectors/userInfoSelectors';

const FolderSubscriptionArea = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userId = useSelector(state => selectUserId(state));
  const { documentId, siteId } = useParams();
  const isNewDocument = useMemo(() => getInt(documentId) === null || getInt(siteId) === null, [documentId, siteId]);

  useGlobalSubscription(FOLDER_RESPONSIBLE_UPDATED, {
    variables: {
      documentId: getInt(documentId),
      siteId: getInt(siteId)
    },
    skip: isNewDocument,
    onSubscriptionData: ({ client }) => {
      client.cache.evict({
        id: 'ROOT_QUERY',
        fieldName: `folderHeader({"documentId":${documentId},"siteId":${siteId}})`
      });
      client.cache.evict({
        id: 'ROOT_QUERY',
        fieldName: `folderHeaderAlpha({"documentId":${documentId},"siteId":${siteId}})`
      });
      client.cache.gc();
    }
  });

  useSubscription(DOCUMENT_UPDATED, {
    variables: { documentId: getInt(documentId), siteId: getInt(siteId), userId },
    skip: isNewDocument || userId === null || userId === undefined,
    onSubscriptionData: data => {
      if (data) dispatch(showInfo(t('Folder.ModifiedData'), false, true));
    }
  });

  return <></>;
};

export default FolderSubscriptionArea;
